/*
  c-cellec-chip-filter.js
  スタッフコーデ一覧用チップフィルタ + 仮想ページネーション
  - 軸間 AND × 軸内 OR の絞り込み
  - クライアントサイドで pageSize 単位の仮想ページ分割
  - URL hash で 絞り込み状態 + 現在ページ を保存（共有URL対応）
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-chip-filter]');
  if (!root) return;

  var articleScope = document.querySelector('.cellec-sns-list__articles') || document;
  var articles = Array.prototype.slice.call(
    articleScope.querySelectorAll('[data-article-tags]')
  );
  if (!articles.length) return;

  var countEl = root.querySelector('[data-count]');
  var resetEl = root.querySelector('[data-reset]');
  var emptyEl = root.querySelector('[data-empty]');
  var paginationEl = document.querySelector('[data-chip-pagination]');
  var chips = Array.prototype.slice.call(root.querySelectorAll('.c-cellec-chip-filter__chip'));

  var PAGE_SIZE = 20;
  var totalCount = articles.length;
  var defaultCountLabel = countEl ? countEl.textContent : '';

  // state: { 'テイスト': Set('テイスト_大人モード', ...), '季節': Set('季節_夏') }
  var state = Object.create(null);
  var currentPage = 1;
  var suppressPageReset = false;

  function getActiveAxes() {
    var keys = [];
    for (var k in state) {
      if (state[k] && state[k].size > 0) keys.push(k);
    }
    return keys;
  }

  function setMatches(setObj, tags) {
    var iter = setObj.values();
    var step = iter.next();
    while (!step.done) {
      if (tags.indexOf(step.value) !== -1) return true;
      step = iter.next();
    }
    return false;
  }

  function computeMatched() {
    var axes = getActiveAxes();
    var matched = [];
    for (var i = 0; i < articles.length; i++) {
      var el = articles[i];
      var tagStr = el.getAttribute('data-article-tags') || '';
      var tags = tagStr.split(',');
      var ok = true;
      for (var j = 0; j < axes.length; j++) {
        if (!setMatches(state[axes[j]], tags)) { ok = false; break; }
      }
      if (ok) matched.push(el);
    }
    return matched;
  }

  function applyFilter() {
    var matched = computeMatched();
    var totalPages = Math.max(1, Math.ceil(matched.length / PAGE_SIZE));
    if (currentPage > totalPages) currentPage = totalPages;
    if (currentPage < 1) currentPage = 1;

    var startIdx = (currentPage - 1) * PAGE_SIZE;
    var endIdx = startIdx + PAGE_SIZE;

    // 全件いったん非表示
    for (var i = 0; i < articles.length; i++) {
      articles[i].hidden = true;
      articles[i].style.display = 'none';
    }
    // 現在ページのマッチ記事のみ表示
    for (var k = startIdx; k < Math.min(endIdx, matched.length); k++) {
      matched[k].hidden = false;
      matched[k].style.display = '';
    }

    var axes = getActiveAxes();
    if (countEl) {
      if (axes.length === 0) {
        countEl.textContent = defaultCountLabel || ('全' + totalCount + '件のコーディネート');
      } else {
        countEl.textContent = matched.length + '件のコーディネート';
      }
    }
    if (resetEl) resetEl.hidden = axes.length === 0;
    if (emptyEl) emptyEl.hidden = !(axes.length > 0 && matched.length === 0);

    renderPagination(totalPages);
    syncHashFromState();
  }

  function clearChildren(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function makeNavButton(targetPage, disabled, label, ariaLabel) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'c-cellec-chip-filter-pagination__nav';
    btn.setAttribute('data-page', String(targetPage));
    if (disabled) btn.disabled = true;
    btn.setAttribute('aria-label', ariaLabel);
    btn.textContent = label;
    return btn;
  }

  function makePageButton(pageNum, isActive) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'c-cellec-chip-filter-pagination__page' + (isActive ? ' is-active' : '');
    btn.setAttribute('data-page', String(pageNum));
    if (isActive) btn.setAttribute('aria-current', 'page');
    btn.textContent = String(pageNum);
    return btn;
  }

  function makeEllipsis() {
    var span = document.createElement('span');
    span.className = 'c-cellec-chip-filter-pagination__ellipsis';
    span.textContent = '…';
    return span;
  }

  function renderPagination(totalPages) {
    if (!paginationEl) return;
    clearChildren(paginationEl);
    if (totalPages <= 1) {
      paginationEl.hidden = true;
      return;
    }
    paginationEl.hidden = false;

    paginationEl.appendChild(
      makeNavButton(currentPage - 1, currentPage === 1, '前', '前のページ')
    );

    var pages = buildPageList(totalPages, currentPage);
    pages.forEach(function (p) {
      if (p === '...') {
        paginationEl.appendChild(makeEllipsis());
      } else {
        paginationEl.appendChild(makePageButton(p, p === currentPage));
      }
    });

    paginationEl.appendChild(
      makeNavButton(currentPage + 1, currentPage === totalPages, '次', '次のページ')
    );
  }

  function buildPageList(totalPages, current) {
    // 7個前後の数字 + ... を返す（コンパクト表示）
    if (totalPages <= 7) {
      var arr = [];
      for (var i = 1; i <= totalPages; i++) arr.push(i);
      return arr;
    }
    var result = [1];
    if (current > 3) result.push('...');
    var start = Math.max(2, current - 1);
    var end = Math.min(totalPages - 1, current + 1);
    for (var p = start; p <= end; p++) result.push(p);
    if (current < totalPages - 2) result.push('...');
    result.push(totalPages);
    return result;
  }

  function gotoPage(p) {
    var matched = computeMatched();
    var totalPages = Math.max(1, Math.ceil(matched.length / PAGE_SIZE));
    if (p < 1 || p > totalPages) return;
    currentPage = p;
    applyFilter();
    scrollToListTop();
  }

  function scrollToListTop() {
    var top = root.getBoundingClientRect().top + window.pageYOffset - 40;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function toggleChip(btn) {
    var axis = btn.getAttribute('data-axis');
    var value = btn.getAttribute('data-value');
    if (!axis || !value) return;

    if (!state[axis]) state[axis] = new Set();
    if (state[axis].has(value)) {
      state[axis].delete(value);
      btn.classList.remove('is-active');
      btn.setAttribute('aria-pressed', 'false');
    } else {
      state[axis].add(value);
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    }

    if (!suppressPageReset) currentPage = 1;
    applyFilter();
  }

  function resetAll() {
    state = Object.create(null);
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.remove('is-active');
      chips[i].setAttribute('aria-pressed', 'false');
    }
    currentPage = 1;
    applyFilter();
  }

  function syncHashFromState() {
    var axes = getActiveAxes();
    var parts = axes.map(function (axis) {
      var marker = axis + '_';
      var values = [];
      state[axis].forEach(function (v) {
        values.push(encodeURIComponent(v.indexOf(marker) === 0 ? v.slice(marker.length) : v));
      });
      return encodeURIComponent(axis) + '=' + values.join(',');
    });
    if (currentPage > 1) parts.push('page=' + currentPage);

    if (parts.length === 0) {
      if (location.hash) {
        history.replaceState(null, '', location.pathname + location.search);
      }
      return;
    }
    var newHash = '#' + parts.join('&');
    if (location.hash !== newHash) {
      history.replaceState(null, '', location.pathname + location.search + newHash);
    }
  }

  function restoreFromHash() {
    if (!location.hash || location.hash.length < 2) return;
    var raw = location.hash.slice(1);
    var pairs = raw.split('&');

    suppressPageReset = true;
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      var eq = pair.indexOf('=');
      if (eq === -1) continue;
      var key = decodeURIComponent(pair.slice(0, eq));
      var rawValues = pair.slice(eq + 1);
      if (!key || !rawValues) continue;

      if (key === 'page') {
        var p = parseInt(rawValues, 10);
        if (!isNaN(p) && p >= 1) currentPage = p;
        continue;
      }

      var values = rawValues.split(',').map(decodeURIComponent).filter(Boolean);
      if (!values.length) continue;

      state[key] = new Set();
      var marker = key + '_';
      values.forEach(function (v) {
        var full = v.indexOf(marker) === 0 ? v : marker + v;
        state[key].add(full);
        var btn = root.querySelector(
          '.c-cellec-chip-filter__chip[data-axis="' + cssEscape(key) + '"][data-value="' + cssEscape(full) + '"]'
        );
        if (btn) {
          btn.classList.add('is-active');
          btn.setAttribute('aria-pressed', 'true');
        }
      });
    }
    suppressPageReset = false;
    applyFilter();
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/(["\\\]])/g, '\\$1');
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest ? e.target.closest('.c-cellec-chip-filter__chip') : null;
    if (chip) { toggleChip(chip); return; }
    var reset = e.target.closest ? e.target.closest('[data-reset]') : null;
    if (reset) { resetAll(); }
  });

  if (paginationEl) {
    paginationEl.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('[data-page]') : null;
      if (!btn || btn.disabled) return;
      var page = parseInt(btn.getAttribute('data-page'), 10);
      if (!isNaN(page)) gotoPage(page);
    });
  }

  // 初期描画（hash があれば復元、なければ通常 applyFilter で全件1ページ目）
  if (location.hash && location.hash.length > 1) {
    restoreFromHash();
  } else {
    applyFilter();
  }
})();
